import {
  type AirPriceFreezeMachineContext,
  getAirPriceFreezeInitialContext,
  getCartInitialContext,
} from "@hopper-b2b/checkout";
import {
  type UberPaymentContext,
  getPaymentInitialContext,
} from "../../checkout/states/payments";

export const getInitialPriceFreezeMachineContext =
  (): AirPriceFreezeMachineContext<UberPaymentContext> => {
    return {
      ...getAirPriceFreezeInitialContext(),
      ...getCartInitialContext(),
      ...getPaymentInitialContext(),
    };
  };
